import React, { useState } from 'react';
import { CardContent, TextField } from '@mui/material';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { isValidChar } from '../../lib/user-helpers';

type Props = {
    first?: string;
    last?: string;
    phone?: string;
    countryCode?: string;
    onFirstChanged?: Function;
    onLastChanged?: Function;
    onPhoneChanged?: Function;
    changeNextLabel?: Function;
    changeNextEnabled?: Function;
};

const fieldsComplete = (fields: string[]): boolean => {
    for (let i = 0; i < fields.length; i++) {
        if (fields[i].length < 1) {
            return false;
        }
    }
    return true;
};

export const AccountDetails: React.FC<Props> = (props: Props) => {
    const { t } = useLanguageLocale();
    const {
        first,
        last,
        phone,
        countryCode,
        onFirstChanged,
        onLastChanged,
        onPhoneChanged,
        changeNextLabel,
        changeNextEnabled,
    } = props;
    const [firstName, setFirstName] = useState(first || '');
    const [lastName, setLastName] = useState(last || '');
    const [phoneNumber, setPhoneNumber] = useState(phone || '');
    const [country, setCountryCode] = useState(countryCode || '');

    if (changeNextLabel) {
        changeNextLabel(t('ACTIONS.FINISH'));
    }
    if (changeNextEnabled) {
        changeNextEnabled(fieldsComplete([firstName, lastName, phoneNumber]) && phoneNumber.length === 10);
    }
    const onChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setPhoneNumber(e.target.value);
            setCountryCode(country);
            if (onPhoneChanged) onPhoneChanged(e.target.value, country);
        }
    };
    return (
        <>
            <CardContent style={{ flex: '1 1 0px', overflow: 'auto' }}>
                <TextField
                    style={{ marginTop: 24 }}
                    variant={'filled'}
                    label={t('FORMS.FIRST_NAME')}
                    inputProps={{ 'data-testid': 'first-name', maxLength: 50 }}
                    value={firstName}
                    required
                    fullWidth
                    onChange={(e): void => {
                        if (isValidChar(e.target.value)) {
                            setFirstName(e.target.value);
                            if (onFirstChanged) onFirstChanged(e.target.value);
                        }
                    }}
                />
                <TextField
                    style={{ marginTop: 24 }}
                    variant={'filled'}
                    label={t('FORMS.LAST_NAME')}
                    inputProps={{ 'data-testid': 'last-name', maxLength: 50 }}
                    value={lastName}
                    required
                    fullWidth
                    onChange={(e): void => {
                        if (isValidChar(e.target.value)) {
                            setLastName(e.target.value);
                            if (onLastChanged) onLastChanged(e.target.value);
                        }
                    }}
                />
                <TextField
                    style={{ marginTop: 24, width: '15%', marginRight: 10 }}
                    variant={'filled'}
                    inputProps={{ 'data-testid': 'country-code', maxLength: 2 }}
                    value={country}
                    disabled
                />
                <TextField
                    style={{ marginTop: 24, width: '82%' }}
                    variant={'filled'}
                    label={t('FORMS.PHONE_NUMBER')}
                    inputProps={{ 'data-testid': 'phone-number', maxLength: 10 }}
                    value={phoneNumber}
                    required
                    fullWidth
                    onChange={(e): void => onChangePhoneNumber(e)}
                />
            </CardContent>
        </>
    );
};
